const images = [
    require("../../images/blog-img-6.jpg"), 
    require("../../images/blog-img-8.jpg"), 
    require("../../images/blog-img-9.jpg")
]

export default images